import { render, staticRenderFns } from "./BCKeyAssignmentExtendedMenu.vue?vue&type=template&id=67ccee1f"
import script from "./BCKeyAssignmentExtendedMenu.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentExtendedMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports